import React, { Component } from "react";
import { Modal, Form, Input, Row, Col, Button } from "antd";
import { sendVerifyCode, retrievalPwd } from "api/api";
import Tools from "utils/tools";

const FormItem = Form.Item;

class Forget extends React.Component {
  state = {
    confirmDirty: false,
    isLoading: false,
    isSend: false,
    num: 90
  };
  // 密码验证
  handleConfirmBlur = e => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };
  compareToFirstPassword = (rule, value, callback) => {
    const form = this.props.form;
    if (value && value !== form.getFieldValue("newpassword")) {
      callback("两次密码输入不一致!");
    } else {
      callback();
    }
  };
  validateToNextPassword = (rule, value, callback) => {
    const form = this.props.form;
    if (value && this.state.confirmDirty) {
      form.validateFields(["confirm"], { force: true });
    }
    callback();
  };
  // 表单提交
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.setState({
          isLoading: true
        });
        retrievalPwd({
          phone: values.phone,
          verifyCode: values.captcha,
          password: Tools.encryption(values.newpassword),
          repeatPassword: Tools.encryption(values.confirm)
        })
          .then(res => {
            this.setState({
              isLoading: false
            });
            if (res.code == 0) {
              Modal.success({
                title: "提示",
                content: "密码修改成功"
              });
              this.handleCancel();
            }
          })
          .catch(err => {
            if (!err.isCancel) {
              this.setState({
                isLoading: false
              });
            }
          });
      }
    });
  };
  // 点击获取验证码
  gainVerCode = () => {
    this.props.form.validateFields(["phone"], (err, values) => {
      if (!err) {
        sendVerifyCode({
          phone: values.phone
        }).then(res => {
          if (res.code == 0) {
            Modal.success({
              content: "验证码已发送到您手机，10分钟内输入有效",
              title: "提示"
            });
            this.setState({ isSend: true });
            this.timedCount();
          }
        });
      }
    });
  };
  // 倒计时
  timedCount = () => {
    let num = this.state.num - 1;
    if (num == -1) {
      this.setState({ isSend: false, num: 90 });
      return;
    } else {
      this.setState({ num: num });
      setTimeout(this.timedCount, 1000);
    }
  };
  // 关闭弹框
  handleCancel = () => {
    this.props.form.resetFields();
    this.props.handleVisible(false);
  };
  render() {
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 }
      }
    };

    const { getFieldDecorator } = this.props.form;
    return (
      <Modal
        title="忘记密码"
        visible={this.props.visible}
        centered={true}
        onOk={this.handleSubmit}
        confirmLoading={this.state.isLoading}
        onCancel={this.handleCancel}
        okText="重置密码"
      >
        <Form>
          <FormItem {...formItemLayout} label="手机号">
            {getFieldDecorator("phone", {
              rules: [
                { required: true, message: "请输入正确的手机号!" },
                { pattern: /^1[3456789]\d{9}$/g, message: "手机号码格式错误" }
              ]
            })(<Input style={{ width: "100%" }} placeholder="请输入手机号" />)}
          </FormItem>
          <FormItem {...formItemLayout} label="验证码">
            <Row>
              <Col span={16}>
                {getFieldDecorator("captcha", {
                  rules: [
                    { required: true, message: "请输入短信验证码!" },
                    { max: 6, message: "最大长度6" }
                  ]
                })(<Input placeholder="请输入短信验证码" />)}
              </Col>
              <Col span={8}>
                <Button
                  type="primary"
                  style={{
                    marginLeft: 20,
                    width: "calc(100% - 20px)",
                    boxSizing: "border-box"
                  }}
                  disabled={this.state.isSend}
                  onClick={this.gainVerCode}
                >
                  {this.state.isSend
                    ? `${this.state.num}s重新获取`
                    : "获取验证码"}
                </Button>
              </Col>
            </Row>
          </FormItem>
          <FormItem {...formItemLayout} label="重置密码">
            {getFieldDecorator("newpassword", {
              rules: [
                {
                  required: true,
                  message: "请输入新密码!"
                },
                {
                  pattern: /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]{6,20}$/,
                  message:
                    "6~20位数字与字母的组合！"
                },
                {
                  validator: this.validateToNextPassword
                }
              ]
            })(
              <Input
                type="password"
                placeholder="6~20位数字与字母的组合！"
              />
            )}
          </FormItem>
          <FormItem {...formItemLayout} label="确认密码">
            {getFieldDecorator("confirm", {
              rules: [
                {
                  required: true,
                  message: "请再次输入新密码!"
                },
                {
                  validator: this.compareToFirstPassword
                }
              ]
            })(
              <Input
                type="password"
                onBlur={this.handleConfirmBlur}
                placeholder="6~20位数字与字母的组合！"
              />
            )}
          </FormItem>
        </Form>
      </Modal>
    );
  }
}

export default Form.create()(Forget);
